import { z } from "zod";

export const MemberSchema = z.object({
  organization_id: z.string(),
  user_id: z.string(),
  role: z.string(),
  id: z.string(),
  created_at: z.string(),
});

export const OrganizationSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string().nullish(),
  logo: z.string().nullish(),
  members: z.array(MemberSchema),
  settings: z.unknown().nullish(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type Member = z.infer<typeof MemberSchema>;
export type Organization = z.infer<typeof OrganizationSchema>;
